


























import Vue, { PropType } from "vue"
import PApplicationThanksModal from "./local/PApplicationThanksModal.vue"
import PFloatingInterestedButton from "./local/PFloatingInterestedButton.vue"
import ButtonFloatingFrame from "~/components/custom/buttonFrame/BottomFloatingFrame.vue"
import RoundFavoriteIconButton from "~/components/custom/favoriteButton/RoundFavoriteIconButton.vue"
import PProjectApplyPanel from "~/components/custom/projectApplyPanel/PProjectApplyPanel.vue"
import { ProjectView, decorateProjectView } from "~/backendApis/viewModel"
import { BackendApi } from "~/backendApis"
import { ParticularWriteAcl } from "~/config/acl/accessControlList"

interface DataType {
  isVisibleThanksModal: boolean
  // プロジェクト応募処理中であるかどうかを示すフラグ
  isApplying: boolean
  // プロジェクト応募状態（未応募・応募済み）を確認済みであるかどうかを示すフラグ
  isAlreadyCheckedApplyStatus: boolean
  // プロジェクトが応募済みであるかどうかを示すフラグ
  isAlreadyApplied: boolean
}

export default Vue.extend({
  components: {
    ButtonFloatingFrame,
    RoundFavoriteIconButton,
    PFloatingInterestedButton,
    PProjectApplyPanel,
    PApplicationThanksModal,
  },
  props: {
    project: {
      type: Object as PropType<ProjectView>,
      required: true,
    },
  },
  data(): DataType {
    return {
      isVisibleThanksModal: false,
      isApplying: false,
      isAlreadyCheckedApplyStatus: false,
      isAlreadyApplied: false,
    }
  },
  computed: {
    isUserAppliableForProject(): boolean {
      return this.$clAuth.hasPermission(ParticularWriteAcl.PROJECT_APPLY)
    },
    isProjectOpenForApplication(): boolean {
      return decorateProjectView(this.project).isOpenForApplication()
    },
    isShownProjectApplyPanel(): boolean {
      return this.$clStores.projectApplyMessage.getters.isShownProjectApplyPanel
    },
    isVisibleBottonFloatingFrame(): boolean {
      return (
        this.isUserAppliableForProject &&
        this.isProjectOpenForApplication &&
        !this.isShownProjectApplyPanel
      )
    },
    isFavorited(): boolean {
      return this.$clStores.favoriteProjectList.getters.isFavorited(
        this.project.id
      )
    },
    applyMessage(): string {
      return this.$clStores.projectApplyMessage.getters.applyMessage
    },
  },
  async created() {
    const userProfile = await new BackendApi.User.UserProfileSearch.GetCurrentUserProfileReadRequest().get()
    const cnt = userProfile?.selfIntroduction?.length ?? 0
    this.$clStores.projectApplyMessage.actions.updateIsApplicable(cnt >= 100)

    const projectApplication = await new BackendApi.User.Matching.GetProjectApplicationReadRequest(
      {
        projectId: this.project.id,
      }
    ).get()

    // プロジェクト応募情報を取得できた場合、応募状態を応募済みにする
    if (projectApplication) {
      this.updateApplyStatusToAlreadyApplied()
    }

    this.isAlreadyCheckedApplyStatus = true
  },
  beforeMount() {
    this.$clStores.projectApplyMessage.actions.closeProjectApplyPanel()
    this.$clStores.projectApplyMessage.actions.initializeStateForNewProject(
      this.project.id
    )
    this.$clStores.favoriteProjectList.actions.refreshList()
  },
  methods: {
    openProjectApplyPanel() {
      this.$clStores.projectApplyMessage.actions.openProjectApplyPanel()
    },
    closeProjectApplyPanel() {
      this.$clStores.projectApplyMessage.actions.closeProjectApplyPanel()
    },
    openThanksModal() {
      this.isVisibleThanksModal = true
    },
    hideThanksModal() {
      this.isVisibleThanksModal = false
    },
    updateApplyStatusToAlreadyApplied() {
      this.isAlreadyApplied = true
    },
    toggleFavoriteStatus() {
      this.$gtag("event", "click_project_favorite", {
        projectId: this.project.id,
        isFavorited: !this.isFavorited,
      })
      this.$clStores.favoriteProjectList.actions.toggleFavoriteStatus(
        this.project.id
      )
    },
    async apply() {
      if (!this.applyMessage) {
        this.$clStores.flashMessage.actions.drawFlashError(
          " 応募メッセージを入力してください"
        )
        return
      }

      const applicationMessage =
        "\n以下のプロジェクトについてお話をお聞きしたいです。\n\n" +
        `${this.project.title || ""}\n` +
        `${process.env.SERVICE_BASE_URL}/projects/${this.project.id}\n\n` +
        "プロフィール\n" +
        `${process.env.SERVICE_BASE_URL}/profiles/${this.$clAuth.userIdOrFail}\n\n` +
        this.applyMessage

      if (applicationMessage.length >= 1000) {
        this.$clStores.flashMessage.actions.drawFlashError(
          " 応募メッセージの文字数を750文字以下にしてから送信ください。"
        )
        return
      }

      this.isApplying = true
      this.$gtag("event", "application_project", {
        project_id: this.project.id,
        message_length: applicationMessage.length,
      })
      await new BackendApi.User.Matching.ApplyForProjectWriteRequest({
        projectId: this.project.id,
        applicationMessage,
      })
        .post()
        .catch((e) => {
          alert(
            "応募に失敗しました。再度お試しいただくか、お時間を空けてから再度お試しください。"
          )
          this.isApplying = false
          throw e
        })
      this.updateApplyStatusToAlreadyApplied()
      this.closeProjectApplyPanel()
      this.openThanksModal()
    },
  },
})
